/* eslint-disable @typescript-eslint/return-await */
import { AxiosResponse } from "axios";
import API from "../api";

const ROUTE_NAME = "settings/group-mfa";

export enum MfaMethod {
  EMAIL = 'email',
  SMS = 'sms',
}

export enum MfaEnvironment {
  WEB = 'web',
  OPERATIONS_APP = 'operations_app',
  SALES_APP = 'sales_app',
}

export interface GroupMfaSettings {
  groupId: number;
  groupName: string;
  enabled: boolean;
  method?: MfaMethod;
  environments: MfaEnvironment[];
  createdAt: Date;
  updatedAt: Date;
}

export interface UpdateGroupMfaSettingsDto {
  groupId: number;
  enabled: boolean;
  method?: MfaMethod;
  environments?: MfaEnvironment[];
}

const GroupMfaSettingsService = {
  /**
   * Get MFA settings for a specific group
   */
  async getGroupMfaSettings(groupId: number): Promise<AxiosResponse<GroupMfaSettings | null>> {
    return await API.get(`/${ROUTE_NAME}/group/${groupId}`);
  },

  /**
   * Get MFA settings for all groups in a company
   */
  async getAllGroupMfaSettings(companyId: number): Promise<AxiosResponse<GroupMfaSettings[]>> {
    return await API.get(`/${ROUTE_NAME}/company/${companyId}`);
  },

  /**
   * Update MFA settings for a group
   */
  async updateGroupMfaSettings(
    groupId: number,
    data: Omit<UpdateGroupMfaSettingsDto, 'groupId'>
  ): Promise<AxiosResponse<GroupMfaSettings>> {
    return await API.put(`/${ROUTE_NAME}/group/${groupId}`, data);
  },

  /**
   * Delete MFA settings for a group
   */
  async deleteGroupMfaSettings(groupId: number): Promise<AxiosResponse<{ success: boolean }>> {
    return await API.delete(`/${ROUTE_NAME}/group/${groupId}`);
  },

  /**
   * Check if MFA is enabled for a group and environment
   */
  async isGroupMfaEnabled(
    groupId: number,
    environment: MfaEnvironment
  ): Promise<AxiosResponse<{ enabled: boolean }>> {
    return await API.post(`/${ROUTE_NAME}/group/${groupId}/check`, { environment });
  },
};

export default GroupMfaSettingsService;
